export const PASSWORD_EXPIRED_NOTICE_KEY = "passwordExpiredNotice";
export const PASSWORD_EXPIRED_MESSAGE = "Your password has expired. Reset it below.";
export const SESSION_EXPIRED_NOTICE_KEY = "sessionExpiredNotice";
export const SESSION_EXPIRED_MESSAGE = "Your session expired. Please sign in again.";
export const ACCOUNT_STATE_CHECK_FAILED_NOTICE_KEY = "accountStateCheckFailedNotice";
export const ACCOUNT_STATE_CHECK_FAILED_MESSAGE = "Unable to verify your account state. Please try again.";
export const AUTH_NOTICE_UPDATED_EVENT = "auth-notice-updated";
